import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { LorenzFormGroup } from '../../lorenz-form-group';
import { LorenzFormControl } from '../../lorenz-form-control';
import { LibFormValidityDotComponent } from '../../components/validity-dot/lib-form-validity-dot.component';
import { LorenzFormComponentDisplayOptions, LorenzFormComponentOptionsDefault } from '../../interfaces/lorenz-form-component-options.interface';
import { getLorenzFormLayoutEnumString, LorenzFormLayoutEnum } from '../../enums/lorenz-form-layout.enum';
import { NgClass } from '@angular/common';

@Component({
	selector: 'lib-form-control-checkbox',
	imports: [ReactiveFormsModule, TranslateModule, LibFormValidityDotComponent, NgClass],
	templateUrl: './lib-form-control-checkbox.component.html',
	styleUrl: './lib-form-control-checkbox.component.scss'
})
export class LibFormControlCheckboxComponent implements OnInit {
	@Input({ required: true, alias: 'control' }) lorenzFormControl!: LorenzFormControl;

	@Input({ required: false, alias: 'options' }) lorenzFormComponentDisplayOptions: LorenzFormComponentDisplayOptions = {};

	@Input({ required: false }) isGroupCheck = false;

	@HostBinding('attr.id') hostId = '';

	@HostBinding('attr.class') hostCssClass = '';

	lorenzFormGroup!: LorenzFormGroup;

	ngOnInit() {
		this.lorenzFormGroup = this.lorenzFormControl.parent as LorenzFormGroup;

		this.lorenzFormControl.payload.displayOptions = this.lorenzFormComponentDisplayOptions;

		this.hostId = this.lorenzFormControl.getFullKey();

		// prettier-ignore
		this.hostCssClass = [
				this.lorenzFormControl.getKey(),
				this.isGroupCheck ? 'group-check' : null,
				getLorenzFormLayoutEnumString(this.lorenzFormComponentDisplayOptions?.layout ?? null)
			].join(' ');
	}

	get isLayoutFloatingLabels(): boolean {
		return this.lorenzFormComponentDisplayOptions?.layout === LorenzFormLayoutEnum.FLOATING_LABELS;
	}

	get showErrorMessages(): boolean {
		return this.lorenzFormControl.showErrors() && (this.lorenzFormComponentDisplayOptions.showErrorMessages ?? LorenzFormComponentOptionsDefault.showErrorMessages);
	}

	readonlyHandler(event: MouseEvent) {
		if ((!this.isGroupCheck && this.lorenzFormControl?.isReadonly()) || this.lorenzFormControl?.isLocked()) {
			event.preventDefault();
		}
	}
}
